import React from 'react';

import { NYCLandingType } from '@utils/types/landings';
import FAQs from '@components/_shared/faqs';
import TitleAndDescriptionWithOrder from '@components/nycLanding/_shared/titleAndDescriptionWithOrder';

import styles from './styles.module.scss';

type Props = {
  order: number;
} & NYCLandingType['faq'];

const FAQ = (props: Props) => {
  const { title, faqItems, order } = props;

  return (
    <div className={styles.faq}>
      <TitleAndDescriptionWithOrder title={title} order={order} />

      <FAQs
        faqs={
          faqItems?.map((f) => ({
            question: f.question,
            answerRaw: f.answerRaw,
          })) || []
        }
        containerStyle={styles.faq__wrapper}
        theme="dark"
        noBorder
        highlightSelected
      />
    </div>
  );
};

export default FAQ;
